import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import { useAlert } from "react-alert";
// import MathTypeEditor from "./MathTypeEditor";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../actions/commonActions";
import {
  addQuestion,
  clearErrors,
} from "../../../actions/adminQuestionActions";
import { ADD_QUESTION_RESET } from "./../../../constants/adminQuestionConstants";
import makeAnimated from "react-select/animated";

import Loader from "../../Loader";

import "./Question.css";




import FroalaEditor from 'react-froala-wysiwyg';
import { froalaConfig, withFroalaLicense } from '../../../utils/froalaConfig';

import QuestionForm from "./QuestionForm";
import { getUniversityList } from "../../../actions/adminUniversityAction";

// Flat toolbar list so MathType/WIRIS buttons are always visible (not hidden in "more" menus).
const editorToolbarButtons = [
  'bold',
  'italic',
  'underline',
  'strikeThrough',
  'subscript',
  'superscript',
  'fontFamily',
  'fontSize',
  'textColor',
  'backgroundColor',
  'clearFormatting',
  '|',
  'alignLeft',
  'alignCenter',
  'alignRight',
  'alignJustify',
  'formatOL',
  'formatUL',
  'paragraphFormat',
  'lineHeight',
  '|',
  'insertLink',
  'insertImage',
  'insertVideo',
  'insertTable',
  'insertFile',
  'emoticons',
  'specialCharacters',
  '|',
  'wirisEditor',
   'wirisChemistry',
  // '|',
  'undo',
  'redo',
  'fullscreen',
  'html',
];

const buildEditorConfig = (overrides = {}) =>
  withFroalaLicense({
    ...froalaConfig,
    height: 200,
    ...overrides,
  });

const AddQuestion = ({ history, match }) => {
  const alert = useAlert();
  const dispatch = useDispatch();
  const animatedComponents = makeAnimated();

  const subject = localStorage.getItem("subjectName");
  const examSlug = localStorage.getItem("examSlug");
  const [university, setUniversity] = useState([]);
  const [universityLists, setuniversityLists] = useState([]);
  const [editorContents, setEditorContents] = React.useState([]);
  const { universityList, loading, isUniversityDeleted } = useSelector((state) => state.university);


  useEffect(() => {
    dispatch(getUniversityList())
  }, [])



  const [questionData, setQuestionData] = useState({
    title: "",
    passage_check: false,
    passage: "",
    question: "",
    option_1: "",
    option_2: "",
    option_3: "",
    option_4: "",
    correct_answer: "",
    description: "",
    logo: "",
    status: false,
    imageName: "",
  });
  const [trial, setTrial] = useState(false);

  const createEmptyFormRow = () => ({
    index: `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
    questionTitle: "",
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    option5: "",
    rightAnswer: "",
    answerDesc: "",
  });

  const [formList, setFormList] = useState(() => [createEmptyFormRow()]);



  const handleAnswerChange = (e) => {
    const {dataset, value, checked} = e.target;
    const idx = Number(dataset.id);

    setFormList(prevList => {
      const updated = [...prevList];
      if (!Number.isNaN(idx) && updated[idx]) {
        updated[idx] = {
          ...updated[idx],
          rightAnswer: checked ? value : "",
        };
      }
      return updated;
    });
  };

  const addNewRow = () => {
    setFormList(prevList => [...prevList, createEmptyFormRow()]);
    // setEditorContents([...editorContents, ""]);
  };

  const deteteRow = (index) => {
    setFormList(prevList => prevList.filter((_, sindex) => index !== sindex));
  };

  const clickOnDelete = (record) => {
    setFormList(prevList => prevList.filter((r) => r.index !== record.index));
    // setEditorContents(editorContents.filter((_, i) => record.index !== i));
  };

  const [errorData, setErrorData] = useState({});

  const { title, passage_check, passage, question, status, logo, imageName } =
    questionData;
  const universityId = localStorage.getItem("universityId");
  const subjectId = match.params.subjectId;
  const yearId = match.params.yearId;
  const sectionId = match.params.sectionId;
  const topicId = match.params.topicId;

  const { isQuestionAdded, user_loading, error, errors } = useSelector(
    (state) => state.questionDetail
  );

  const changePassageText = (txt) => {
    setQuestionData({
      ...questionData,
      passage: txt,
    });
  };

  useEffect(() => {

    if (universityId && universityLists?.length > 0) {
      const temp = [];
      const local = universityLists.find((item) => item.value == universityId)
      temp.push(local)
      setUniversity(temp)
    }

    return () => {

    }
  }, [universityId, universityLists])


  // console.log(university);


  const changeEditorText = (data) => {
    setQuestionData({
      ...questionData,
      question: data,
    });

    setFormList(prevList => {
      const updated = [...prevList];
      if (updated[0]) {
        updated[0] = {
          ...updated[0],
          questionTitle: data,
        };
      }
      return updated;
    });
  };

  const handleChange = (e) => {
    const {dataset, name, value} = e.target;
    const idx = Number(dataset.id);

    if (Number.isNaN(idx)) {
      return;
    }

    setFormList(prevList => {
      const updated = [...prevList];
      if (updated[idx]) {
        updated[idx] = {
          ...updated[idx],
          [name]: value,
        };
      }
      return updated;
    });
  };

  const changeLinkedQuestionText = (fieldName, idx, content) => {
    setFormList(prevList => {
      const updated = [...prevList];
      if (updated[idx]) {
        updated[idx] = {
          ...updated[idx],
          [fieldName]: content,
        };
      }
      return updated;
    });
  };

  useEffect(() => {
    dispatch(getAllCategories());

    if (errors) {
      setErrorData(errors);
    }

    if (error) {
      clearErrors();
      return alert.error(error);
    }

    if (isQuestionAdded === true && isQuestionAdded != undefined) {
      alert.success("Question successfully added.");
      history.push(`/admin/questions/${sectionId}/${subjectId}/${yearId}/${topicId}`);
      dispatch({
        type: ADD_QUESTION_RESET,
      });
    }
  }, [dispatch, isQuestionAdded, alert, error, errors]);

  const onChange = (e) => {
    if (e.target.name === "logo") {

      let file = e.target.files[0];

      if (!file.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        setQuestionData({
          ...questionData,
          logo: "",
          imageName: "",
        });
        alert.error("Please select valid logo.");
        //remove preview picture if any
        const preview = document.getElementById("img-preview");
        preview.src = "";
        return false;
      }

      const reader = new FileReader();

      reader.onload = function (readerEvt) {
        // The file's text will be printed here
        let binaryString = readerEvt.target.result;
        let base64String = btoa(binaryString);
        setQuestionData({
          ...questionData,
          logo: base64String,
          imageName: file.name,
        });

        //preview picture
        const preview = document.getElementById("img-preview");
        preview.src = "data:image/png;base64," + base64String;
      };
      reader.readAsBinaryString(file);
    } else if (e.target.name === "passage_check") {

      // console.log("event check", e.target.name, passage_check);

      if (passage_check == true) {
        // setEditorContents([...editorContents, ""]);
        setFormList([createEmptyFormRow()])
      }

      setQuestionData({
        ...questionData,
        passage_check: !passage_check,
      });
    } else if (e.target.name === "status") {
      setQuestionData({
        ...questionData,
        status: !status,
      });
    } else {
      setQuestionData({
        ...questionData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const setCorrectAnswer = (answer) => {
    setQuestionData({
      ...questionData,
      correct_answer: answer,
    });
  };



  const submitHandler = (e) => {
    e.preventDefault();

    if (formList && formList[0]?.rightAnswer == '') {
      alert.error("Please select atleast one correct answer.");
    } else {

      const isExist = university.find((item) => item.value == universityId)
      let temp = []

      if (isExist) {
        temp = [...university]
      } else if (!isExist) {
        temp = [...university]
        const local = universityLists.find((item) => item.value == universityId)
        temp.push(local)
      }


      // console.log("data add","subjID",subjectId,
      //     "SubjId",topicId,
      //     "yearId",yearId,
      //     "sectionId",sectionId,
      //     "title",title,
      //     "Passage chek",passage_check,
      //     "Passage",passage,
      //     "formList",formList,
      //     "status",status,
      //     "Logo",logo,
      //     "image Name",imageName,
      //     "Temp",temp,
      //     "ExamName",examSlug)

      const questionPayload = formList.map((entry) => ({
        ...entry,
        trial,
      }));

      dispatch(
        addQuestion(
          subjectId,
          topicId,
          yearId,
          sectionId,
          title,
          passage_check,
          passage,
          questionPayload,
          status,
          trial,
          logo,
          imageName,
          temp,
          examSlug

        )
      );
    }
  };

  return (
    <Fragment>
      {user_loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Add
                <small>Question</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard" /> Dashboard
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/admin/questions/${sectionId}/${subjectId}/${yearId}/${topicId}`}
                  >
                    <i className="fa fa-users" /> Questions
                  </Link>
                </li>
                <li className="active">Add Question</li>
              </ol>
            </section>

            <section className="content">
              <div className="box box-default">
                <div className="box-header with-border">
                  <h3 className="box-title">Add Question</h3>
                </div>

                <form
                  id="quickForm"
                  onSubmit={submitHandler}
                  encType="multipart/form-data"
                >
                  <div className="box-body">
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="title">Title</label>
                        <input
                          type="text"
                          name="title"
                          className="form-control"
                          id="title"
                          placeholder="Enter Title"
                          value={title}
                          onChange={onChange}
                        />
                        {errorData.title ? (
                          <span className="text-danger">{errorData.title}</span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {examSlug == 'post-utme' && <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="title">Select University</label>

                        <Select
                          value={university}
                          onChange={setUniversity}
                          options={universityLists}
                          isMulti
                          components={animatedComponents}
                          isSearchable={true}
                        />

                      </div>
                    </div>}

                    {true && (
                      <Fragment>
                        <div className="form-group row">
                          <div className="col-md-6">
                            <label htmlFor="passage_check">
                              {subject === "english" ? "Common Passage / Linked Question" : "Linked Question"}
                            </label>
                            <input
                              style={{ marginRight: "5px" }}
                              type="checkbox"
                              className="form-check-input"
                              id="passage_check"
                              name="passage_check"
                              checked={passage_check}
                              value={passage_check}
                              onChange={onChange}
                            />
                          </div>
                        </div>

                        {passage_check === true && (
                          <div className="form-group row">
                            <div className="col-md-12">
                              <label htmlFor="Passage_Image">{subject !== "english" ? "Question Information" : "Passage / Question Information"} </label>
                              <FroalaEditor
                                tag='textarea'
                                model={passage ?? ''}
                                onModelChange={changePassageText}
                                config={buildEditorConfig()}
                              />

                              {errorData.passage ? (
                                <span className="text-danger">
                                  {errorData.passage}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )}
                      </Fragment>
                    )}

                    {!passage_check && (
                      <div className="form-group row">
                        <div className="col-md-12 customCKeditor">
                          <label htmlFor="question">Question</label>
                          <FroalaEditor
                            tag='textarea'
                            model={question ?? ''}
                            onModelChange={changeEditorText}
                            config={buildEditorConfig()}
                          />

                          {/* <Editor
                            apiKey="nag9rfyktzweza49mzb77l9378ilslwdo58xufcns615clff"
                            initialValue="<p>This is the initial content of the editor</p>"
                            init={{
                              height: 500,
                              plugins: 'math',
                              toolbar: 'math',
                              mathTypeParameters: {
                                lang: 'en',
                                dir: 'ltr',
                                base: 'https://www.wiris.net/demo/plugins/app/WIRISplugins.js',
                                format: 'mathml', // or 'image' for image output
                              },
                              plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount '
                              ],
                              external_plugins: {
                                'tiny_mce_wiris': `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`
                              },
                              toolbar: [
                                ' bold italic |' +
                                "tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry | " +
                                "undo redo | formatselect " +
                                "bold italic backcolor | alignleft aligncenter alignright alignjustify | MathType" +
                                "bullist numlist outdent indent | " +
                                "removeformat | help | image code ",
                              ],
                              htmlAllowedTags: ['.*'],
                              htmlAllowedAttrs: ['.*'],
                              extended_valid_elements: '*[.*]',
                              paste_data_images: true,
                              file_picker_types: 'image',
                            }}
                            onEditorChange={(newText) =>
                              changeEditorText(newText)
                            }
                          /> */}
                          {/* <MathTypeEditor /> */}
                          {errorData.questionTitle ? (
                            <span className="text-danger">
                              {errorData.questionTitle}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    )}

                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="logo">Image</label>
                        <input
                          type="file"
                          className="form-control"
                          id="logo"
                          name="logo"
                          onChange={onChange}
                          accept={`.jpeg, .jpg, .png`}
                        // required
                        />
                        {errorData.logo ? (
                          <span className="text-danger">{errorData.logo}</span>
                        ) : (
                          ""
                        )}
                        <div>
                          <img id="img-preview" src="" alt="" />
                        </div>
                      </div>
                    </div>

                    <div className="questionData">
                      <QuestionForm
                        handleChange={handleChange}
                        handleAnswerChange={handleAnswerChange}
                        add={addNewRow}
                        delete={clickOnDelete.bind(this)}
                        formList={formList}
                        subject={subject}
                        passage_check={passage_check}
                        changeLinkedQuestionText={changeLinkedQuestionText}
                        // changeLinkedQuestionOptionText={changeLinkedQuestionOptionText}
                        editorContent={editorContents}
                      />
                    </div>

                    <div className="form-group row">
                      <div className="col-md-6">
                        <label htmlFor="trial">Demo / Trial Question</label>
                        <input
                          style={{ marginRight: "5px" }}
                          type="checkbox"
                          className="form-check-input"
                          id="trial"
                          name="trial"
                          checked={trial}
                          value={trial}
                          onChange={() => setTrial((prev) => !prev)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="status">Status</label>
                        <input
                          style={{ marginRight: "5px" }}
                          type="checkbox"
                          className="form-check-input"
                          id="status"
                          name="status"
                          checked={status}
                          value={status}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="box-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default AddQuestion;
